export default __webpack_public_path__ + "static/media/self.0ce608c1.png";